import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEntity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 10.694V5.30601C14 4.82934 13.746 4.38934 13.3333 4.15134L8.66667 1.45734C8.254 1.21934 7.746 1.21934 7.33333 1.45734L2.66667 4.15067C2.254 4.38934 2 4.82934 2 5.30601V10.6947C2 11.1713 2.254 11.6113 2.66667 11.8493L7.33333 14.5433C7.746 14.7813 8.254 14.7813 8.66667 14.5433L13.3333 11.8493C13.746 11.6107 14 11.1707 14 10.694Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00008 14.72V8",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8.00001L13.82 4.64001",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.17993 4.64001L7.99993 8.00001",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgEntity as ReactComponent };
